import axios from 'axios'
import { Message, MessageBox } from 'xlian-ui'
import store from '@/store'
import { getToken, getPlatformToken } from '@/utils/auth'
import {
  SYSTEM_SUCCESS,
  SYSTEM_AUTH_FAIL,
  PLATFORM_TYPE,
  BIZ_TYPE
} from '@/utils/constants'
import md5 from 'js-md5'
import router from '@/router'

const BASE_CONFIG = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  headers: {
    platformType: PLATFORM_TYPE,
    bizType: BIZ_TYPE,
    platform: 'emi',
    outer: 'web'
  }
}

const service = axios.create(BASE_CONFIG)

service.interceptors.request.use(
  async (config) => {
    await store.dispatch('version/startListenVersionChange')
    config.headers.versionDay = store.getters.versionDay
    if (!store.getters.isCurrentVersion) {
      MessageBox.confirm('检测到新版本，是否更新？', '新版本', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        location.reload()
      })
    }

    // 如果是file接口 修改url
    if (config.fileFlag) {
      config.url = process.env.VUE_APP_BUSINESS_FILE_BASE_API + config.url
    }

    // headers 添加token
    if (getToken()) {
      config.headers['Authorization'] = getToken()
    }

    // md5加数字签名
    const timestamp = new Date().getTime()
    config.headers['timestamp'] = timestamp
    config.headers['sign'] = md5(
      `${JSON.stringify(config.data)}${timestamp}${getToken()}`
    )
    if (!config.hideLoading) {
      store.dispatch('app/showLoading')
    }

    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data || {}

    if (response.config.hideLoading !== false) {
      store.dispatch('app/hideLoading')
    }

    /** 兼容文件下载 */
    if (res instanceof Blob || res instanceof ArrayBuffer) {
      return Promise.resolve(res)
    }

    switch (res.code) {
      case SYSTEM_SUCCESS:
        return res
      case SYSTEM_AUTH_FAIL:
        router.onReady(() => {
          router.push({
            path: '/login'
          })
        })
      // MessageBox.confirm(res.msg, '提示', {
      //   confirmButtonText: '确认',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   store.dispatch('user/resetToken').then(() => {
      //     location.reload()
      //   })
      // })
      // eslint-disable-next-line no-fallthrough
      case 800102003:
        return res
      default:
        Message.closeAll()
        Message({
          message: res.msg,
          type: 'error',
          duration: 4 * 1000
        })
        return Promise.reject(new Error(res.msg))
    }
  },
  (error) => {
    store.dispatch('app/hideLoading')
    Message.closeAll()
    Message({
      message: error || '网络异常',
      type: 'error',
      duration: 4 * 1000
    })
    return Promise.reject(error)
  }
)

export const preflightService = axios.create(BASE_CONFIG)

preflightService.interceptors.response.use((response) => {
  const result = response.data || {}

  switch (result.code) {
    case SYSTEM_SUCCESS:
      return Promise.resolve(result)
    default:
      return Promise.reject(result.error || 'Error')
  }
})

export default service
